export default __webpack_public_path__ + "static/media/success-check.66e30b54.svg";